<div class="no-data-container">
  <img class="product-img" src="/assets/e-commerce/icons/47.webp" />
  <p class="no-data-text">{{ "No orders" | transloco }}</p>
  <button class="btn btn-add" routerLink="/Home" style="margin-bottom: 10px;">{{ "shopping" | transloco
    }}</button>
</div>